<template>
  <div class="facility-limits">
    <!-- Small Models Limit -->
    <v-row no-gutters class="mt-2">
      <v-col cols="12" class="" no-gutters>
        <div class="text-subtitle-1">Small Models Limit:</div> 
        <v-row no-gutters>
          <v-col cols="6" class="d-flex align-center " >
            <v-checkbox
              v-model="unlimitedSmallModels"
              label="Unlimited"
              dense
              hide-details
              class="mb-2 mr-2"
            />
            <div style="gap: 8px; max-width: 360px;"  v-if="!unlimitedSmallModels">
              <v-text-field
            
           
            v-model="smallModelsLimitCount"
            :rules="[formRules.required, validateSmallModelsLimit]"
            dense
            outlined
            hide-details
            type="number"
            placeholder="Small Models Limit Count"
          />
              </div>
          
          </v-col>
          <v-col cols="6" class="d-flex align-center justify-end progress-wrapper">
            <CountProgress
              :count="facilityData.smallModelsLimitUsed || 0"
              :limit="facilityData.smallModelsLimitCount"
              :unlimited="+facilityData.smallModelsLimitCount === -1"
              icon="mdi-folder-cog-outline"
              title="Small Models"
              size="small"
            />
          </v-col>
        </v-row>
      </v-col>
      <div class="py-2 w-100">
        <v-divider></v-divider>
      </div>
    </v-row>
    
    <!-- Scans Upload Limit -->
    <v-row no-gutters>
      <v-col cols="12" class="" no-gutters>
        <div class="text-subtitle-1">Scans Uploads Limit:</div> 
        <v-row no-gutters>
          <v-col cols="6" class="d-flex align-center">
            <v-checkbox
              v-model="unlimitedScanUploads"
              label="Unlimited"
              dense
              hide-details
              class="mb-2 mr-2"
            />
            <div
              v-if="!unlimitedScanUploads"
              class="d-flex align-center"
              style="gap: 8px; max-width: 360px;"
            >
              <v-text-field
                v-model.number="scanUploadInput"
                :rules="[formRules.required, validateScanUploadLimit]"
                dense
                outlined
                hide-details
                type="number"
                placeholder="Scans Uploads Limit"
              />
             
            </div>
          </v-col>
          <v-col cols="6" class="d-flex align-center justify-end progress-wrapper">
            <CountProgress
              :count="facilityData.scanUploadLimitUsed || 0"
              :limit="facilityData.scanUploadLimit"
              :unlimited="+facilityData.scanUploadLimit === -1"
              icon="mdi-upload"
              title="Scans Upload"
              size="small"
            />
          </v-col>
        </v-row>
      </v-col>
      <div class="py-2 w-100">
        <v-divider></v-divider>
      </div>
    </v-row>
    
    <!-- Scans Download Limit -->
    <v-row no-gutters>
      <v-col cols="12" class="" no-gutters>
        <div class="text-subtitle-1">Scans Downloads Limit:</div> 
        <v-row no-gutters>
          <v-col cols="6" class="d-flex align-center">
            <v-checkbox
              v-model="unlimitedScanDownloads"
              label="Unlimited"
              dense
              hide-details
              class="mb-2 mr-2"
            />
            <div
              v-if="!unlimitedScanDownloads"
              class="d-flex align-center"
              style="gap: 8px; max-width: 360px;"
            >
              <v-text-field
                v-model.number="scanDownloadInput"
                :rules="[formRules.required, validateScanDownloadLimit]"
                dense
                outlined
                hide-details
                type="number"
                placeholder="Scans Downloads Limit"
              />
              <v-select
                :items="scanSizeUnits"
                v-model="scanDownloadUnit"
                dense
                attach
                outlined
                hide-details
                label="Unit"
                style="max-width: 110px"
              />
            </div>
          </v-col>
          <v-col cols="6" class="d-flex align-center justify-end progress-wrapper">
            <CountProgress
              :count="facilityData.scanDownloadLimitUsed || 0"
              :limit="facilityData.scanDownloadLimit"
              :unlimited="+facilityData.scanDownloadLimit === -1"
              icon="mdi-download"
              title="Scans Download"
              type="fileSize"
              size="small"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@Share/config/form-rules';
import CountProgress from '@/features/Company/components/CountProgress.vue';

export default {
  name: 'FacilityLimits',
  components: {
    CountProgress
  },
  props: {
    facilityData: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formRules,
      // Limit handling properties
      unlimitedSmallModels: false,
      unlimitedScanUploads: false,
      unlimitedScanDownloads: false,
      smallModelsPrevLimit: null,
      scanUploadPrevLimit: null,
      scanDownloadPrevLimit: null,
      // UI state for scan size limit inputs
      scanSizeUnits: ['MB', 'GB', 'TB'],
      scanUploadUnit: 'GB',
      scanDownloadUnit: 'GB',
      scanUploadInput: 0,
      scanDownloadInput: 0,
      // Internal guards to prevent watcher feedback loops
      syncingScanUpload: false,
      syncingScanDownload: false,
      // Local model for small models limit
      smallModelsLimitCount: 0
    };
  },
  created() {
    this.initializeData();
  },
  methods: {
    initializeData() {
      // Initialize UI state based on facility data
      this.unlimitedSmallModels = +this.facilityData.smallModelsLimitCount === -1;
      this.unlimitedScanUploads = +this.facilityData.scanUploadLimit === -1;
      this.unlimitedScanDownloads = +this.facilityData.scanDownloadLimit === -1;
      
      // Set local model for small models limit
      this.smallModelsLimitCount = this.facilityData.smallModelsLimitCount;
      
      // Initialize scan size units and inputs
      this.initScanLimitsUI();
    },
    // Validation methods for limits
    validateSmallModelsLimit(value) {
      if (this.unlimitedSmallModels || value === -1) return true;
      return true;
    },
    validateScanUploadLimit(  ) {
      if (this.unlimitedScanUploads) return true;
      return true;
    },
    validateScanDownloadLimit() {
      if (this.unlimitedScanDownloads) return true;
      return true;
    },
    // Scan size unit helpers
    unitMultiplier(unit) {
      switch (unit) {
        case 'TB': return 1024 * 1024; // MB per TB (1024-based)
        case 'GB': return 1024;        // MB per GB
        case 'MB':
        default: return 1;
      }
    },
    pickBestUnit(mbVal) {
      const v = Number(mbVal) || 0;
      if (v >= 1024 * 1024) return 'TB';
      if (v >= 1024) return 'GB';
      return 'MB';
    },
    syncScanUploadUI() {
      if (this.unlimitedScanUploads || +this.facilityData.scanUploadLimit === -1) return;
      this.syncingScanUpload = true;
      try {
        const unit = this.scanUploadUnit || this.pickBestUnit(this.facilityData.scanUploadLimit);
        if (!this.scanUploadUnit) this.scanUploadUnit = unit;
        const mult = this.unitMultiplier(unit);
        const val = Number(this.facilityData.scanUploadLimit) / mult;
        this.scanUploadInput = Number.isFinite(val) ? +val : 0;
      } finally {
        this.$nextTick(() => { this.syncingScanUpload = false; });
      }
    },
    syncScanDownloadUI() {
      if (this.unlimitedScanDownloads || +this.facilityData.scanDownloadLimit === -1) return;
      this.syncingScanDownload = true;
      try {
        const unit = this.scanDownloadUnit || this.pickBestUnit(this.facilityData.scanDownloadLimit);
        if (!this.scanDownloadUnit) this.scanDownloadUnit = unit;
        const mult = this.unitMultiplier(unit);
        const val = Number(this.facilityData.scanDownloadLimit) / mult;
        this.scanDownloadInput = Number.isFinite(val) ? +val : 0;
      } finally {
        this.$nextTick(() => { this.syncingScanDownload = false; });
      }
    },
    updateScanUploadDraftFromUI() {
      if (this.syncingScanUpload) return;
      if (this.unlimitedScanUploads) return;
      const mult = this.unitMultiplier(this.scanUploadUnit);
      const mb = Math.round((Number(this.scanUploadInput) || 0) * mult);
      if (this.facilityData.scanUploadLimit !== mb) {
        this.$emit('update:scanUploadLimit', mb);
      }
    },
    updateScanDownloadDraftFromUI() {
      if (this.syncingScanDownload) return;
      if (this.unlimitedScanDownloads) return;
      const mult = this.unitMultiplier(this.scanDownloadUnit);
      const mb = Math.round((Number(this.scanDownloadInput) || 0) * mult);
      if (this.facilityData.scanDownloadLimit !== mb) {
        this.$emit('update:scanDownloadLimit', mb);
      }
    },
    initScanLimitsUI() {
      // Upload
      if (+this.facilityData.scanUploadLimit !== -1) {
        const u = this.pickBestUnit(this.facilityData.scanUploadLimit);
        this.scanUploadUnit = u;
        const mult = this.unitMultiplier(u);
        this.scanUploadInput = Math.max(0, +(Number(this.facilityData.scanUploadLimit) / mult).toFixed(2));
      }
      // Download
      if (+this.facilityData.scanDownloadLimit !== -1) {
        const u = this.pickBestUnit(this.facilityData.scanDownloadLimit);
        this.scanDownloadUnit = u;
        const mult = this.unitMultiplier(u);
        this.scanDownloadInput = Math.max(0, +(Number(this.facilityData.scanDownloadLimit) / mult).toFixed(2));
      }
    }
  },
  watch: {
    facilityData: {
      handler() {
        this.initializeData();
      },
      deep: true
    },
    unlimitedSmallModels(val) {
      if (val) {
        this.smallModelsPrevLimit = (this.smallModelsLimitCount !== -1 ? this.smallModelsLimitCount : this.smallModelsPrevLimit) ?? 0;
        this.smallModelsLimitCount = -1;
        this.$emit('update:smallModelsLimitCount', -1);
      } else {
        const restore = (this.smallModelsPrevLimit != null && this.smallModelsPrevLimit !== -1) ? this.smallModelsPrevLimit : 0;
        this.smallModelsLimitCount = restore;
        this.$emit('update:smallModelsLimitCount', restore);
      }
    },
    unlimitedScanUploads(val) {
      if (val) {
        this.scanUploadPrevLimit = (this.facilityData.scanUploadLimit !== -1 ? this.facilityData.scanUploadLimit : this.scanUploadPrevLimit) ?? 0;
        this.$emit('update:scanUploadLimit', -1);
      } else {
        const restore = (this.scanUploadPrevLimit != null && this.scanUploadPrevLimit !== -1) ? this.scanUploadPrevLimit : 0;
        this.$emit('update:scanUploadLimit', restore);
      }
      this.$nextTick(this.syncScanUploadUI);
    },
    unlimitedScanDownloads(val) {
      if (val) {
        this.scanDownloadPrevLimit = (this.facilityData.scanDownloadLimit !== -1 ? this.facilityData.scanDownloadLimit : this.scanDownloadPrevLimit) ?? 0;
        this.$emit('update:scanDownloadLimit', -1);
      } else {
        const restore = (this.scanDownloadPrevLimit != null && this.scanDownloadPrevLimit !== -1) ? this.scanDownloadPrevLimit : 0;
        this.$emit('update:scanDownloadLimit', restore);
      }
      this.$nextTick(this.syncScanDownloadUI);
    },
    smallModelsLimitCount(v) {
      this.unlimitedSmallModels = +v === -1;
      this.$emit('update:smallModelsLimitCount', v);
    },
    // UI value/unit watchers -> update selected
    scanUploadUnit() {
      this.updateScanUploadDraftFromUI();
    },
    scanUploadInput() {
      this.updateScanUploadDraftFromUI();
    },
    scanDownloadUnit() {
      this.updateScanDownloadDraftFromUI();
    },
    scanDownloadInput() {
      this.updateScanDownloadDraftFromUI();
    }
  }
};
</script>

<style scoped>
.facility-limits {
  width: 100%;
}
.progress-wrapper {
  min-height: 40px;
}
</style>
